import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { AgsTotalCreditsTextControl } from "../ags-total-credits-text-control";

export class AgsTotalCreditsTextControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        return layer.getFlexiText("total_in_credits") != null;
    }

    public build(layer: Layers): AgsTotalCreditsTextControl[] {
        return [
            new AgsTotalCreditsTextControl(layer.getFlexiText("total_in_credits"))
        ];
    }
}
